/**
 * Compare what different user types see for the same course
 * This will help identify if Admin sees different data
 */

import { getCourseById } from '../services/courseService';
import { fetchAuthSession } from 'aws-amplify/auth';

export async function compareUserViews() {
  const COURSE_ID = '045ef510-0d3d-41f7-808e-e75a77cb765c';
  
  console.log('🔍 COMPARING USER VIEWS OF COURSE');
  console.log('=' .repeat(50));
  
  try {
    // Get current user info
    const session = await fetchAuthSession();
    const token = session.tokens.idToken.toString();
    
    // Parse token to get user info
    const tokenParts = token.split('.');
    const payload = JSON.parse(atob(tokenParts[1]));
    const userEmail = payload.email;
    const groups = payload['cognito:groups'] || [];
    
    console.log('\n👤 CURRENT USER:');
    console.log('Email:', userEmail);
    console.log('Groups:', groups);
    console.log('Primary Group:', groups[0]);
    
    // Get course
    const course = await getCourseById(COURSE_ID);
    
    console.log('\n📚 COURSE AS SEEN BY', groups[0] || 'User');
    console.log('Title:', course.title);
    console.log('Status:', course.status);
    console.log('Status (JSON):', JSON.stringify(course.status));
    console.log('Status === "published"?', course.status === 'published');
    
    // Check for any group-specific fields
    console.log('\n🔍 CHECKING FOR GROUP-SPECIFIC DATA:');
    const groupSpecificFields = [
      'adminStatus', 'studentStatus', 'guardianStatus',
      'isPublished', 'isActive', 'isAvailable',
      'adminOnly', 'studentOnly', 'guardianOnly'
    ];
    
    groupSpecificFields.forEach(field => {
      if (course[field] !== undefined) {
        console.log(`Found ${field}:`, course[field]);
      }
    });
    
    // Check all status-like fields
    console.log('\n📋 ALL STATUS-LIKE FIELDS:');
    Object.keys(course).forEach(key => {
      if (key.toLowerCase().includes('status') || 
          key.toLowerCase().includes('state') ||
          key.toLowerCase().includes('published') ||
          key.toLowerCase().includes('active')) {
        console.log(`${key}:`, course[key], `(JSON: ${JSON.stringify(course[key])})`);
      }
    });
    
    // Raw course object
    console.log('\n📦 RAW COURSE OBJECT:');
    console.log(JSON.stringify(course, null, 2));
    
    return course;
    
  } catch (error) {
    console.error('Comparison failed:', error);
  }
}

window.compareUserViews = compareUserViews;